module.exports = __webpack_public_path__ + "static/media/rectangle-view-on.44ab4360.svg";